// store/actions/interviewActions.js
export const GET_SCHEDULED_REQUEST = 'GET_SCHEDULED_REQUEST'
export const GET_SCHEDULED_SUCCESS = 'GET_SCHEDULED_SUCCESS'
export const GET_SCHEDULED_FAILURE = 'GET_SCHEDULED_FAILURE'
export const CLEAR_SCHEDULED_ERROR = 'CLEAR_SCHEDULED_ERROR'
export const RESET_SCHEDULED = 'RESET_SCHEDULED'
export const FILTER_BY_ROUNDS = 'FILTER_BY_ROUNDS'
export const GET_SHORTLISTED_REQUEST = 'GET_SHORTLISTED_REQUEST'
export const GET_SHORTLISTED_SUCCESS = 'GET_SHORTLISTED_SUCCESS'
export const GET_SHORTLISTED_FAILURE = 'GET_SHORTLISTED_FAILURE'

// Action Creators
export const getScheduledInterview = (tenant, uid) => {
  return async dispatch => {
    dispatch({ type: GET_SCHEDULED_REQUEST })
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(
        `${tenant.getApiUrl('interview')}/id?jdUid=${uid}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      )

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`)
      }

      const data = await response.json()
      dispatch({
        type: GET_SCHEDULED_SUCCESS,
        payload: data.res || data.data || []
      })
    } catch (error) {
      dispatch({
        type: GET_SCHEDULED_FAILURE,
        payload: error.message
      })
    }
  }
}

export const getShortlistedPipeline = tenant => {
  return async dispatch => {
    dispatch({ type: GET_SHORTLISTED_REQUEST })
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(
        `${tenant.getApiUrl('interview')}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      )

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`)
      }

      const data = await response.json()
      dispatch({
        type: GET_SHORTLISTED_SUCCESS,
        payload: data.res || data.data || []
      })
    } catch (error) {
      dispatch({
        type: GET_SHORTLISTED_FAILURE,
        payload: error.message
      })
    }
  }
}

export const clearScheduledError = () => ({
  type: CLEAR_SCHEDULED_ERROR
})

export const resetScheduled = () => ({
  type: RESET_SCHEDULED
})

export const filterByRounds = data => ({
  type: FILTER_BY_ROUNDS,
  payload: data
})
